import { getFallbackValueIfNull } from 'owa-options-core';
import store from '../data/store/store';
import { getCalendarConfiguration } from 'owa-calendar-configuration';
/**
 * Gets the fallback value for time increment option in calendar appearance settings
 */
export default (function () {
    return getFallbackValueIfNull(store().timeIncrement, getCalendarConfiguration().TimeIncrement);
});
//# sourceMappingURL=getTimeIncrement.js.map